import update from "./update";
import addOrUpdateOwnUrl from "./addOrUpdateOwnUrl";
import addOrUpdateCompetitorsUrls from "./addOrUpdateCompetitorsUrls";
import get from "./get";
import deleteCompetitorUrl from "./deleteCompetitorUrl";
import updateReviews from "./updateReviews";
import getById from "./getById";
import openOrCloseDoor from "./openOrCloseDoor";
import openOrCloseDoorById from "./openOrCloseDoorById";
import openOrCloseRentalDoor from "./openOrCloseRentalDoor";
import getCurrentBookings from "./getCurrentBookings";
import updateAlerts from "./updateAlerts";
import getAirbnbListings from "./getAirbnbListings";
import generateEmail from "./generateEmail";
import updateForward from "./updateForward";
import deconnectBooking from "./deconnectBooking";
import getRentalEvents from "./getRentalEvents";
import updateRentalExpedia from "./updateRentalExpedia";
import addGroup from "./addGroup";
import getGroups from "./getGroups";
import updateGroup from "./updateGroup";
import deleteGroup from "./deleteGroup";
import deleteInvoiceLogo from "./deleteInvoiceLogo";
import deleteRentalImage from "./deleteRentalImage";
import getRentalsList from "./getRentalsList";
import getProperties from "./getProperties";
import syncData from "./syncData";
import fetchBookingAndRental from "./fetchBookingAndRentalByHash";
import importAirbnbListingsToBeds24 from "./importAirbnbListingsToBeds24";
import updateRental from "./updateRental";
import getAccountListings from "./getAccountListings";
import getRoomAvailabilityAndPrice from "./getRoomAvailabilityAndPrice";
import getAll from "./getAll";
import getRentalGroups from "./getRentalGroups";
import syncRoomDates from "./syncRoomDates";
import getNewAirbnbRentals from "./getNewAirbnbRentals";
import getBookingComRoomsAndRatesCodes from "./getBookingComRoomsAndRatesCodes";
import destroy from "./destroy";
import removeWithBookings from "./removeWithBookings";
import addIcal from "./addIcal";
import getIcals from "./getIcals";
import deleteIcal from "./deleteIcal";
import editPlatforms from "./editPlatforms";
import storeFiles from "./storeFiles";
import storeRental from "./storeRental";
import updateRentalServices from "./updateRentalServices";
import getIcalRestrictions from "./getIcalRestrictions";
import importBookingsFromFile from "./importBookingsFromFile";
import importBookingReservationsFromFile from "./importBookingReservationsFromFile";
import importBookingsData from "./importBookingsData";
import getRoomAvailabilities from "./getRoomAvailabilities";
import syncRentalReservations from "./syncRentalReservations";
import updateRentalsOrder from "./updateRentalsOrder";
import syncRentalRestrictions from "./syncRentalRestrictions";
import syncPriceLab from "./syncPriceLab";
import deleteReduction from "./deleteReduction";
import syncPriceLabAllPrices from "./syncPriceLabAllPrices";
import setDynamicPriceSettings from "./setDynamicPriceSettings";
import assignTeamMemberToRental from "./assignTeamMemberToRental";
import desyncAirbnb from "./desyncAirbnb";
import updateRentalAirbnbData from "./updateRentalAirbnbData";

export default {
  update,
  addGroup,
  addOrUpdateOwnUrl,
  addOrUpdateCompetitorsUrls,
  get,
  updateGroup,
  deleteGroup,
  getGroups,
  deleteCompetitorUrl,
  updateReviews,
  updateAlerts,
  getById,
  openOrCloseDoor,
  openOrCloseDoorById,
  openOrCloseRentalDoor,
  getCurrentBookings,
  getAirbnbListings,
  generateEmail,
  updateForward,
  deconnectBooking,
  getRentalEvents,
  updateRentalExpedia,
  deleteInvoiceLogo,
  deleteRentalImage,
  getRentalsList,
  getProperties,
  syncData,
  fetchBookingAndRental,
  importAirbnbListingsToBeds24,
  updateRental,
  getAccountListings,
  getRoomAvailabilityAndPrice,
  getAll,
  getRentalGroups,
  syncRoomDates,
  getNewAirbnbRentals,
  getBookingComRoomsAndRatesCodes,
  destroy,
  removeWithBookings,
  addIcal,
  getIcals,
  deleteIcal,
  editPlatforms,
  storeFiles,
  storeRental,
  updateRentalServices,
  getIcalRestrictions,
  importBookingsFromFile,
  importBookingReservationsFromFile,
  importBookingsData,
  getRoomAvailabilities,
  syncRentalReservations,
  updateRentalsOrder,
  syncRentalRestrictions,
  syncPriceLab,
  deleteReduction,
  setDynamicPriceSettings,
  syncPriceLabAllPrices,
  assignTeamMemberToRental,
  desyncAirbnb,
  updateRentalAirbnbData,
};



// WEBPACK FOOTER //
// ./src/app/services/rental/index.js